import React from "react";
import * as api from '../../api';
import H2 from "../Atoms/H2";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import ImageBox from "../Atoms/ImageBox";
import Section from "../Atoms/Section";
import UppercaseInfo from "../Atoms/UppercaseInfo";
import BoldBlue from "../Atoms/BoldBlue";
import Spinner from "../../Plateforme/Atoms/Spinner";
import CityCommaCountry from "../Utils/CityCommaCountry";
import BlueButton from "../Atoms/BlueButton";
import SocialNetworksDisplay from "../Atoms/SocialNetworksDisplay";
import Events from "../Atoms/Events";
import FormatActivité from "../Utils/FormatActivité";
import DateAdhésion from "../Atoms/DateAdhésion";
import Text10LinesMax from "../Atoms/Text10LinesMax";
import DefaultCompanyCover from "../Utils/DefaultCompanyCover";
import { userHasFullAccess } from "../Utils/Validator";
import { dateHsTodateFront } from "../Utils/Format";
import H0 from "../Atoms/H0";
import DynamicallyTranslatedText from "../Atoms/DynamicallyTranslatedText";


const Profile = (props) => {

    const [user, setUser] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    const { i18n } = useTranslation('common');
    const navigate = useNavigate();
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const public_view = urlParams.get('public_view') === "1";
    const email = atob(id);

    // console.log("public_view : " + public_view);

    React.useEffect(() => {
        if(loading) return;
        if(props.fullUserLoading) return;
        if(!user.user) return;
        if((props.fullUser?.user?._id !== user?.user?._id) && !userHasFullAccess(props.fullUser, props.fullUserLoading) && !public_view){
            navigate('/');
        }
    }, [props.fullUser, props.fullUserLoading, user, loading]);

    React.useEffect(() => {
        if(!email) {navigate('/'); return};
        api.GetAllUserData({email}).then((response) => {
            // console.log("user gotten :");
            // console.log(response.data);
            setUser(response.data);
            setLoading(false);
        }).catch((error) => {
            console.log(error);
        });
    }, [email,navigate]);

    if(loading){
        return (
            <>
                <br/><br/><br/>
                <Spinner/>
            </>
        )
    }

    const showApropos = (i18n.language === "fr" ? user.hsProfile?.presentation_libre_fr : user.hsProfile?.presentation_libre_en) || user.user.creditphoto || user.user.creditcover;

    const currentCoverPath = (user.user?.cover && (process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + user.user.cover)) || DefaultCompanyCover(user.company);

    return (
        <div>
            <Section>
                <ImageBox
                    currentImagePath={currentCoverPath}
                    width="100%"
                    height="400px"
                />
            </Section>
            <Section className="padding flexblock" style={{alignItems:'center'}}>
                <H0>{user.hsProfile?.firstname.toUpperCase()} {user.hsProfile?.lastname.toUpperCase()}</H0>
                {(props.fullUser?.user?._id === user.user._id || props.fullUser?.user?.role === 'admin') && 
                    <BlueButton onClick={() => navigate('/myprofile?id=' + btoa(user.user.email))} style={{display:"inline-block", cursor:'pointer'}}>
                        {i18n.language === "fr" ? "✎ modifier" : "✎ edit"}
                    </BlueButton>
                }
            </Section>
            <Section className="padding">
                {/* {user.hsProfile?.jobtitle && <><UppercaseInfo>{i18n.language === "fr" ? "Poste :" : "Position:"}</UppercaseInfo>   <UppercaseInfo className="blue">{user.hsProfile?.jobtitle}</UppercaseInfo><br/></>} */}
                {user.hsProfile?.jobtitle && <><UppercaseInfo>{i18n.language === "fr" ? "Poste :" : "Position:"}</UppercaseInfo>   <UppercaseInfo className="blue"><DynamicallyTranslatedText text={user.hsProfile?.jobtitle} targetLang={i18n.language} context={"Job title"} /></UppercaseInfo><br/></>}
                <UppercaseInfo>{i18n.language === "fr" ? "Société :" : "Company:"}</UppercaseInfo>   <UppercaseInfo style={{cursor:"pointer"}} onClick={() => navigate('/company?id=' + user.company?._id + (public_view ? "&public_view=1" : ""))} className="blue"><img src='/img/fleche_bleue.png' alt='' />{user.hsCompany?.properties?.name}</UppercaseInfo><br/>
                {user.hsProfile?.cat_gories_via && <><UppercaseInfo>{i18n.language === "fr" ? "Activité professionnelle :" : "Professional activity:"}</UppercaseInfo>   <UppercaseInfo className="blue">{FormatActivité(user.hsProfile?.cat_gories_via, i18n.language)}</UppercaseInfo><br/></>}
                <DateAdhésion date={user.hsProfile?.date_adhesion_club_le_french_design}/>
            </Section>
            <Section className="flexblock">
                <div style={{flex:'2'}}>
                    <div className="flexblock" style={{alignItems:'flex-start'}}>
                        <div>
                            {user.hsProfile?.seniority && <>
                                <BoldBlue>{i18n.language === "fr" ? "Années d'expériences" : "Years of experience"}</BoldBlue><br/>
                                {user.hsProfile?.seniority}<br/><br/>
                            </>}
                            {(user.user.showmail || (user.hsProfile?.phone && user.user.showphone) || (user.hsProfile?.mobilephone && user.user.showmobilephone)) && <><BoldBlue>Contact</BoldBlue><br/></>}
                            {user.user.showmail && <><span>{user.hsProfile?.email}</span><br/></>}
                            {user.hsProfile?.mobilephone && user.user.showmobilephone && <><span>{user.hsProfile?.mobilephone}</span><br/></>}
                            {user.hsProfile?.phone && user.user.showphone && <><span>{user.hsProfile?.phone}</span><br/></>}
                            <br/>
                            {CityCommaCountry(user.hsProfile) && <>
                                <BoldBlue>{i18n.language === "fr" ? "Adresse" : "Address"}</BoldBlue><br/>
                                {CityCommaCountry(user.hsProfile)}<br/><br/>
                            </>}
                            <Events events={user.hsProfile?.events}/>
                            <br/><br/>
                        </div>
                        <div>
                            {user.hsProfile?.date_of_birth && user.user.showdate_of_birth && <>
                                <BoldBlue>{i18n.language === "fr" ? "Date de naissance" : "Date of birth"}</BoldBlue><br/>
                                <span>{dateHsTodateFront(user.hsProfile?.date_of_birth)}</span><br/><br/>
                            </>}
                            {user.hsProfile?.nationalite && <>
                                <BoldBlue>{i18n.language === "fr" ? "Nationalité" : "Nationality"}</BoldBlue><br/>
                                {/* <span>{user.hsProfile?.nationalite}</span><br/><br/> */}
                                <span><DynamicallyTranslatedText text={user.hsProfile?.nationalite} targetLang={i18n.language} context={"Nationality of someone"} /></span><br/><br/>
                            </>}
                            {user.hsProfile?.langues && <>
                                <BoldBlue>{i18n.language === "fr" ? "Langues" : "Languages"}</BoldBlue><br/>
                                {/* <span>{user.hsProfile?.langues.replaceAll(';',', ')}</span><br/><br/> */}
                                <span><DynamicallyTranslatedText text={user.hsProfile?.langues.replaceAll(';',', ')} targetLang={i18n.language} context={"Languages spoken by a user"} /></span><br/><br/>
                            </>}
                        </div>
                    </div>
                    <div className="flexblock">
                        {user.user.cv && <span style={{flex:"none"}}>
                            <a href={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + user.user.cv} target="_blank" rel="noreferrer"><BlueButton><img src='/img/fleche_blanche.png' alt='' />{i18n.language === "fr" ? "Aperçu du CV" : "View resume"}</BlueButton></a>
                        </span>}
                        {user.user.cv && <span style={{flex:"none"}}>
                            <a href={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + user.user.cv + "?downloadfile=true"}><BlueButton><img src='/img/import.png' alt='' />{i18n.language === "fr" ? "Télécharger le CV" : "Download resume"}</BlueButton></a>
                        </span>}
                        <SocialNetworksDisplay
                            twitter={user.hsProfile?.twitterhandle}
                            instagram={user.hsProfile?.instagram_account}
                            linkedin={user.hsProfile?.lien_linkedin}
                        />
                    </div>
                </div>
                <div style={{borderLeft:"1px solid black",paddingLeft:"20px"}}>
                    <ImageBox
                        currentImagePath={user.user?.portrait && (process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + user.user?.portrait)}
                        width="400px"
                        height="400px"
                    />
                    {user.user.creditphoto && <p style={{fontSize:"12px",color:"#aaa",textAlign:"center",marginTop:'5px'}}>
                        {i18n.language === "fr" ? "Crédit :" : "Credit:"} {user.user.creditphoto}<br/>
                    </p>}
                </div>
            </Section>
            {showApropos && <>
                <Section className="padding">
                    <H2>{i18n.language === "fr" ? "À PROPOS" : "ABOUT"}</H2>
                </Section>
                <Section className="flexblock">
                    <div style={{flex:'2'}}>
                        <Text10LinesMax>{i18n.language === "fr" ? user.hsProfile?.presentation_libre_fr : user.hsProfile?.presentation_libre_en}</Text10LinesMax>
                    </div>
                    <div>
                        <p style={{fontSize:"12px",color:"#aaa"}}>
                            {user.user.creditcover && <>{i18n.language === "fr" ? "Photo de couverture :" : "Cover picture:"} {user.user.creditcover}<br/></>}
                        </p>
                    </div>
                </Section>
            </>}
        </div>
    );
};

export default Profile;